<template>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button class="pill next-pill-button" @click="save('userForm')" :disabled="formsData.userForm.gst.value == userData.gst">
                <span>Save</span>
            </ion-button>
        </ion-buttons>
        <ion-title>My Profile</ion-title>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <!-- <PageTitle title="GST Registered" subtitle="Are you registered for GST?" /> -->
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>GST Registered</h1>
                    <p class="auth-subtext">Are you registered for GST?</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                @submit.prevent="goNext('userForm')" @keyup.enter="goNext('userForm')">
                <el-form-item>
                    <el-radio-group v-model="formsData.userForm.gst.value">
                        <el-radio v-for="item in formsData.userForm.gst.data" :key="item.value" :label="item.value">
                            {{ item.label }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div class="bg-overlay"></div>
        </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
</template>

<script>

import {
    onMounted,
    inject,
} from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";

addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import {
    useRouter,
    onBeforeRouteLeave,
} from "vue-router";
import formHooks from "@/hooks/form/form";


// import formValidate from "@/hooks/form/validate/validate";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';



export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        IonTitle,
        SvgIcon,
    },

    setup() {
        const $store = useStore();
        const $router = useRouter();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);

        const userData = $store.getters.GET_USER_DATA;
        const userRole = userData.role;

        const formsDataArray = {
            userForm: {
                gst: {
                    data: [{ value: '0', label: 'No' }, { value: '1', label: 'Yes' }],
                    value: userData.gst === 0 ? '0' : '1',
              
                },
                // gstNumber: {
                //     value: userData.gst_number || '',
                //     validators: [
                //         {
                //             validator: (rule, formField, callback) => {
                //                 formValidate.validate(rule, formField, "gstNumber", callback, setFormValidation);
                //             },
                //             trigger: 'change'
                //         }
                //     ]
                // }
            },
        };


        const goBack = () => {
            $router.push({
                name: "profile",
            });
        };

        const save = (formName) => {
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    return (async () => {
                        try {
                            console.log(formName)
                            const data = getFormValues(formName);
                            console.log(data)
                            $store.dispatch("SAVE_USER_DATA", data)
                            copyFormResetValue("userForm", true);
                            // goBack();
                            $router.push({
                                name: "profile_edit",
                            });
                        } catch (errors) {
                            checkFormValidation(formName, true);
                        }
                    })();

                } else {
                    setFormValidation(formName, false, false);
                    console.log("error submit!!");
                    return false;
                }
            });
        };

        onBeforeRouteLeave((to, from, next) => {
            (async () => {
                try {
                    let leave = await checkFormChanged("userForm");
                    if (leave == "save") {
                        await save("userForm");
                    } else if (!leave) {
                        next(false);
                    } else {
                        next();
                    }
                } catch (error) {
                    next(false);
                    console.log(error);
                }
            })();
        });

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            checkFormValidation("userForm", true);
        });

        const {
            checkFormValidation,
            setFormValidation,
            copyFormResetValue,
            checkFormChanged,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);


        return {
            formsData,
            checkFormValidation,
            goBack,
            save,
            userData,
            userRole,
        };
    },
};
</script>
